export default "__VITE_ASSET__BaBcf3$5__"